var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('k-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"size":"xs","color":_vm.color},on:{"click":_vm.update}},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }